import React from 'react';
import Card from '../components/card';
import { CityStateAddress } from '../components/city-state-address';
import { LoanCard } from './card-lenses';

const wrappedFunc = (func) => (prop, ...args) =>
  func(`loan${prop[0].toUpperCase()}${prop.substr(1)}`, ...args);

/**
 * Collect the city and state of the property with the accepted offer.
 */
const AcceptedAddress = ({ model, onChange, ...cardProps }) => (
  <Card title="In what city is your new home located?" {...cardProps}>
    <CityStateAddress
      model={{
        get: wrappedFunc(model.get.bind(model))
      }}
      onChange={wrappedFunc(onChange)}
      id="acceptedAddress"
      addressLabel="Address"
    />
  </Card>
);

AcceptedAddress.completed = ({ model }) => model.get('loanCity') && model.get('loanState');

AcceptedAddress.id = 'City';

export default LoanCard(AcceptedAddress);



// WEBPACK FOOTER //
// ./src/cards/accepted-address.js